import React from 'react';

// const IMAGE_URL = "https://www.acrisure.com/_next/image?url=https%3A%2F%2Fedge.sitecorecloud.io%2Facrisurellc1-acrisure-prod-0dbe%2Fmedia%2FProject%2FAcrisure%2FAcrisure-Site%2FMaster-Site%2FPages%2FWhy-Acrisure%2FPromo-full.png%3Fh%3D978%26iar%3D0%26w%3D1792&w=3840&q=75";

function Stats() {
  return (
    <section className="bg-[#0e1e52] py-24 px-4">
      <div className="max-w-7xl mx-auto">
        
        {/* Section heading */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            <span className="text-[#ce381b]">Built on</span> Growth.{' '}
            <span className="text-[#ce381b]">Proven by</span> Results{' '}
        </h2>

        <div className="flex flex-col md:flex-row gap-6">

          {/* Left — big gradient box with image */}
          <div className="md:w-1/2 relative rounded-2xl overflow-hidden min-h-96">
            <img
              src='/image/bg-stats.jpg'
              alt="Stats"
              className="w-full h-full object-cover absolute inset-0"
            />
            {/* Gradient overlay */}
            <div
              className="absolute inset-0 opacity-80"
              style={{ background: 'linear-gradient(135deg, #CC341A, #121F54)' }}
            />
            {/* Content */}
            <div className="relative z-10 p-10 sm:p-12 flex flex-col justify-end h-full min-h-96">
              <h2 className="text-4xl sm:text-5xl font-bold text-white leading-tight">
                98% Client Retention
              </h2>
              <p className="text-white/70 text-lg mt-4">
                Our commitment to excellence has earned us the trust of hundreds of businesses across Indonesia and beyond.
              </p>
            </div>
          </div>

          {/* Right — two boxes stacked */}
          {/* <div className="md:w-1/2 flex flex-col gap-6">

            <div className="bg-gray-50 rounded-2xl p-10 flex-1">
              <p className="text-gray-400 text-sm uppercase tracking-widest mb-4">Experience</p>
              <p className="text-gray-950 font-bold leading-none mb-3" style={{ fontSize: '5rem' }}>60%</p>
              <p className="text-gray-950 text-xl font-semibold">More than 10 Years in Business</p>
              <p className="text-gray-500 text-sm mt-2">Decades of expertise serving clients across multiple industries.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-10 flex-1">
              <p className="text-gray-400 text-sm uppercase tracking-widest mb-4">Growth</p>
              <p className="text-gray-950 font-bold leading-none mb-3" style={{ fontSize: '5rem' }}>40%</p>
              <p className="text-gray-950 text-xl font-semibold">Average Annual Growth</p>
              <p className="text-gray-500 text-sm mt-2">From SMEs to multinationals, we've got them covered.</p>
            </div>

          </div> */}

        </div>

      </div>
    </section>
  );
}

export default Stats;